import type {
    AgreementParty,
    CollectionAgreement,
} from '../components/pages/billing/collection/collectionAgreementModel';

const cleanDocument = (value: string): string => value.replace(/[.\-/\s]/g, '').toUpperCase();

const buildPartyRequest = (party: AgreementParty): Record<string, unknown> => ({
    role: party.role,
    fullName: party.fullName.trim(),
    documentNumber: cleanDocument(party.documentNumber),
});

export const buildAgreementRequest = (agreement: CollectionAgreement): Record<string, unknown> => ({
    externalReference: agreement.externalReference.trim(),
    policyId: agreement.policyId,
    collect: agreement.collect,
    collectionOrder: agreement.collectionOrder.map(step => ({ role: step.role, preventive: step.preventive, overdue: step.overdue })),
    receivingAccountKind: agreement.receivingAccountKind,
    payment: { instruction: agreement.payment.instruction },
    parties: agreement.parties.map(buildPartyRequest),
    notes: (agreement.notes ?? '').trim() || null,
});
